import axiosClient from './axiosClient';
import { ForYouResponse } from '@/types';

export const forYouAPI = {
  getOverview: async (params?: {
    project_limit?: number;
    assigned_limit?: number;
    worked_limit?: number;
  }): Promise<ForYouResponse> => {
    const response = await axiosClient.get<ForYouResponse>('/for-you', { params });
    return response.data;
  },
};

